
<!--Footer-->
<footer class="bg-dark fixed-bottom footer">
    <div>
        <p style="padding-top: 10px;" class="text-white">Editor de Conteúdos-SABER</p>
    </div>
</footer>
<!--Fim Footer-->